import * as i0 from '@angular/core';
import { NgModule, Injectable, InjectionToken, Inject, APP_INITIALIZER, isDevMode, APP_BOOTSTRAP_LISTENER, Directive, Input, Optional, HostListener, Host } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { from } from 'rxjs';
import * as i1$1 from 'angular-google-tag-manager';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import * as i2 from '@angular/router';
import { NavigationEnd, Router } from '@angular/router';
import { __awaiter } from 'tslib';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'angular-google-tag-manager';
import * as ɵngcc3 from '@angular/router';
class AnalyticsModule {
}
AnalyticsModule.ɵfac = function AnalyticsModule_Factory(t) { return new (t || AnalyticsModule)(); };
AnalyticsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AnalyticsModule });
AnalyticsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AnalyticsModule, { imports: function () { return [CommonModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule
                ],
                providers: []
            }]
    }], null, null); })();

class AnalyticsService {
    constructor(http) {
        this.http = http;
    }
    /**
     * @type { Observable }
     * @description Função que retorna a geolocalização
     * @example { latitude: number, longitude: number }
     */
    geolocation() {
        const promise = new Promise((resolve, reject) => {
            try {
                if (navigator.geolocation) {
                    const options = {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 0
                    };
                    navigator.geolocation.getCurrentPosition((position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;
                        resolve({
                            latitude,
                            longitude
                        });
                    }, (err) => {
                        resolve({
                            latitude: null,
                            longitude: null,
                        });
                    }, options);
                }
                else {
                    resolve({
                        latitude: null,
                        longitude: null,
                    });
                }
            }
            catch (err) {
                reject(err);
            }
        });
        return from(promise);
    }
    /**
     * @type { Observable }
     * @description Função que retorna o IP
     * @example { "ip": "177.82.89.86" }
     */
    ip() {
        return this.http.get('https://api.ipify.org?format=json');
    }
    /**
     * @type { String }
     * @description Retorna a URL atual
     */
    currentURL() {
        return window.location.href;
    }
    userAgent() {
        return navigator.userAgent;
    }
    /**
     * @type { Object }
     * @description Retorna a plataforma que o usuário está acessando o site
     * @example { platform: 'Mac OS X', osCode: 4 };
     */
    platform() {
        let platformResult;
        var clientStrings = [
            { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
            { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
            { s: 'Windows Vista', r: /Windows NT 6.0/ },
            { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
            { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
            { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
            { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
            { s: 'Windows 98', r: /(Windows 98|Win98)/ },
            { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
            { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: 'Windows CE', r: /Windows CE/ },
            { s: 'Windows 3.11', r: /Win16/ },
            { s: 'Android', r: /Android/ },
            { s: 'Open BSD', r: /OpenBSD/ },
            { s: 'Sun OS', r: /SunOS/ },
            { s: 'Chrome OS', r: /CrOS/ },
            { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
            { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
            { s: 'Mac OS X', r: /Mac OS X/ },
            { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: 'QNX', r: /QNX/ },
            { s: 'UNIX', r: /UNIX/ },
            { s: 'BeOS', r: /BeOS/ },
            { s: 'OS/2', r: /OS\/2/ },
            { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
        ];
        const platform = navigator.platform;
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(platform)) {
                platformResult = cs.s;
            }
        }
        let osCode;
        let isMobile = false;
        switch (platformResult) {
            case 'Mac OS X':
                osCode = 4;
                break;
            case 'Android':
                osCode = 1;
                isMobile = true;
                break;
            case 'Windows':
                osCode = 5;
                break;
            case 'Linux':
                osCode = 3;
                break;
            case 'iOS':
                osCode = 2;
                isMobile = true;
                break;
            default:
                osCode = 6;
                break;
        }
        return {
            platform: platformResult,
            osCode,
            isMobile,
        };
    }
    isMobile() {
        const isMobile = this.platform();
        return isMobile.isMobile;
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AnalyticsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(i0.ɵɵinject(i1.HttpClient)); }, token: AnalyticsService, providedIn: "root" });
AnalyticsService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

const trackerInjection = new InjectionToken('TrackerInjection');

class TrackerService {
    constructor(gtmService, router, config) {
        this.gtmService = gtmService;
        this.router = router;
        this.config = config;
        try {
            localStorage.setItem('GTM_ID', config.GTM_ID);
        }
        catch (err) { }
        this.enablePageEvent = this.config && this.config.enablePageEvent ? this.config.enablePageEvent : false;
    }
    start() {
        this.pageEvent();
    }
    pageEvent() {
        if (!this.enablePageEvent) {
            return;
        }
        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
                const gtmTag = {
                    event: 'page',
                    pageName: item.url
                };
                this.gtmService.pushTag(gtmTag);
            }
        });
    }
    customEvent(eventConfig) {
        const gtmTag = {
            event: eventConfig.event,
            data: eventConfig.data,
        };
        this.gtmService.pushTag(gtmTag);
    }
}
TrackerService.ɵfac = function TrackerService_Factory(t) { return new (t || TrackerService)(ɵngcc0.ɵɵinject(ɵngcc2.GoogleTagManagerService), ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(trackerInjection)); };
TrackerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TrackerService_Factory() { return new TrackerService(i0.ɵɵinject(i1$1.GoogleTagManagerService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(trackerInjection)); }, token: TrackerService, providedIn: "root" });
TrackerService.ctorParameters = () => [
    { type: GoogleTagManagerService },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [trackerInjection,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.GoogleTagManagerService }, { type: ɵngcc3.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [trackerInjection]
            }] }]; }, null); })();

class TrackerModule {
    static forRoot(trackerConfig) {
        return {
            ngModule: TrackerModule,
            providers: [
                TrackerService,
                GoogleTagManagerService,
                { provide: 'googleTagManagerId', useValue: trackerConfig.GTM_ID ? trackerConfig.GTM_ID : localStorage.getItem('GTM_ID') },
                { provide: trackerInjection, useValue: trackerConfig }
            ],
        };
    }
}
TrackerModule.ɵfac = function TrackerModule_Factory(t) { return new (t || TrackerModule)(); };
TrackerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TrackerModule });
TrackerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        TrackerService,
        GoogleTagManagerService,
    ], imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TrackerModule, { imports: function () { return [CommonModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                providers: [
                    TrackerService,
                    GoogleTagManagerService,
                ]
            }]
    }], null, null); })();

const NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN = new InjectionToken('ngx-hotjar-settings', {
    factory: () => ({ trackingCode: '' })
});

const NGX_GOOGLE_ANALYTICS_INITIALIZER_PROVIDER = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: GoogleAnalyticsInitializer,
    deps: [
        NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN
    ]
};
function GoogleAnalyticsInitializer($settings) {
    return () => __awaiter(this, void 0, void 0, function* () {
        if (!$settings.trackingCode) {
            if (!isDevMode()) {
                console.error('Empty tracking code for Google Analytics. Make sure to provide one when initializing NgxGoogleAnalyticsModule.');
            }
            return;
        }
        // Set default ga.js uri
        $settings.uri = $settings.uri || `https://www.googletagmanager.com/gtag/js?id=${$settings.trackingCode}`;
        // these commands should run first!
        const initialCommands = [
            { command: 'js', values: [new Date()] },
            { command: 'config', values: [$settings.trackingCode] }
        ];
        $settings.initCommands = [...initialCommands, ...($settings.initCommands || [])];
        window['dataLayer'] = window['dataLayer'] || [];
        window['gtag'] = window['gtag'] || function () {
            window['dataLayer'].push(arguments);
        };
        for (const command of $settings.initCommands) {
            window['gtag'](command.command, ...command.values);
        }
        const s = document.createElement('script');
        s.async = true;
        s.src = $settings.uri;
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(s);
    });
}

class GoogleAnalyticsService {
    constructor($trackingId) {
        this.$trackingId = $trackingId;
    }
    throw(err) {
        if (console && console.error) {
            console.error(err);
        }
    }
    /**
     * Call native GA Tag
     *
     * @param action config|event
     * @param command Action specialization
     * @param options Command configuration
     */
    gtag(action, command, ...options) {
        try {
            window['gtag'](action, command, ...options);
        }
        catch (err) {
            this.throw(err);
        }
    }
    /**
     * Send an event trigger to GA. It is the same as call:
     * ```js
     * gtag('event', 'video_auto_play_start', {
     *   'event_label': 'My promotional video',
     *   'event_category': 'video_auto_play'
     * });
     * ```
     *
     * @param action 'video_auto_play_start'
     * @param category 'video_auto_play'
     * @param label 'My promotional video'
     * @param value An value to measure something
     */
    event(action, category, label, value, interaction) {
        try {
            if (window['gtag']) {
                const opt = {};
                if (category) {
                    opt['event_category'] = category;
                }
                if (label) {
                    opt['event_label'] = label;
                }
                if (value) {
                    opt['value'] = value;
                }
                if (interaction !== undefined) {
                    opt['interaction'] = interaction;
                }
                this.gtag('event', action, opt);
            }
        }
        catch (error) {
            this.throw(error);
        }
    }
    /**
     * Send an page view event. This is the same as
     *
     * ```js
     * gtag('config', 'GA_TRACKING_ID', {
     *   'page_title' : 'Homepage',
     *   'page_path': '/home'
     * });
     * ```
     *
     * The tracking ID is injected automatically by Inject Token NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN
     *
     * @param path /home
     * @param title Homepage
     * @param location '{ page_location }'
     * @param options '{ ... custom dimentions }'
     */
    pageView(path, title, location, options) {
        try {
            if (window['gtag']) {
                const opt = {};
                if (path) {
                    opt['page_path'] = path;
                }
                if (title) {
                    opt['page_title'] = title;
                }
                if (location) {
                    opt['page_location'] = location;
                }
                if (options) {
                    Object.assign(opt, options);
                }
                this.gtag('config', this.$trackingId.trackingCode, opt);
            }
        }
        catch (error) {
            this.throw(error);
        }
    }
    /**
     * Send an evento to report a App Page View. It is the same as
     *
     * ```js
     * gtag('event', 'screen_view', {
     *   'app_name': 'myAppName',
     *   'screen_name' : 'Home'
     * });
     *
     * ```
     *
     * @param screen 'screen_name'
     * @param name 'app_name'
     * @param appId 'app_id'
     * @param appVersion 'app_version'
     * @param installerId 'app_installer_id'
     */
    appView(screen, appName, appId, appVersion, installerId) {
        try {
            if (window['gtag']) {
                const opt = {};
                if (screen) {
                    opt['screen_name'] = screen;
                }
                if (appName) {
                    opt['app_name'] = appName;
                }
                if (appId) {
                    opt['app_id'] = appId;
                }
                if (appVersion) {
                    opt['app_version'] = appVersion;
                }
                if (installerId) {
                    opt['app_installer_id'] = installerId;
                }
                this.gtag('event', 'screen_view', opt);
            }
        }
        catch (error) {
            this.throw(error);
        }
    }
    /**
     * Send an event to GA to report an application error. It is the same as
     *
     * ```js
     * gtag('event', 'exception', {
     *   'description': 'error_description',
     *   'fatal': false   // set to true if the error is fatal
     * });
     * ```
     *
     * @param description 'error_description'
     * @param fatal set to true if the error is fatal
     */
    exception(description, fatal) {
        try {
            if (window['gtag']) {
                const opt = {};
                if (description) {
                    opt['description'] = description;
                }
                if (fatal) {
                    opt['fatal'] = fatal;
                }
                this.gtag('event', 'exception', opt);
            }
        }
        catch (error) {
            this.throw(error);
        }
    }
}
GoogleAnalyticsService.ɵfac = function GoogleAnalyticsService_Factory(t) { return new (t || GoogleAnalyticsService)(ɵngcc0.ɵɵinject(NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN)); };
GoogleAnalyticsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function GoogleAnalyticsService_Factory() { return new GoogleAnalyticsService(i0.ɵɵinject(NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN)); }, token: GoogleAnalyticsService, providedIn: "root" });
GoogleAnalyticsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN]
            }] }]; }, null); })();

const NGX_GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER = {
    provide: APP_BOOTSTRAP_LISTENER,
    multi: true,
    useFactory: GoogleAnalyticsRouterInitializer,
    deps: [
        GoogleAnalyticsService,
        Router
    ]
};
function GoogleAnalyticsRouterInitializer($gaService, $router) {
    return (c) => __awaiter(this, void 0, void 0, function* () {
        $router
            .events
            .subscribe(event => {
            if (event instanceof NavigationEnd) {
                $gaService.pageView(event.urlAfterRedirects, undefined, document.location.href);
            }
        });
    });
}

class GaEventCategoryDirective {
    constructor() { }
}
GaEventCategoryDirective.ɵfac = function GaEventCategoryDirective_Factory(t) { return new (t || GaEventCategoryDirective)(); };
GaEventCategoryDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: GaEventCategoryDirective, selectors: [["", "gaEvent", "", "gaCategory", ""], ["", "gaCategory", ""]], inputs: { gaCategory: "gaCategory" }, exportAs: ["gaCategory"] });
GaEventCategoryDirective.ctorParameters = () => [];
GaEventCategoryDirective.propDecorators = {
    gaCategory: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaEventCategoryDirective, [{
        type: Directive,
        args: [{
                selector: `[gaEvent][gaCategory],
             [gaCategory]`,
                exportAs: 'gaCategory'
            }]
    }], function () { return []; }, { gaCategory: [{
            type: Input
        }] }); })();

class GaEventDirective {
    constructor($gaCategoryDirective, $gaService) {
        this.$gaCategoryDirective = $gaCategoryDirective;
        this.$gaService = $gaService;
        this.gaBind = 'click';
    }
    ngOnInit() {
    }
    onClick() {
        if (this.gaBind === 'click') {
            this.trigger();
        }
    }
    onFocus() {
        if (this.gaBind === 'focus') {
            this.trigger();
        }
    }
    onBlur() {
        if (this.gaBind === 'blur') {
            this.trigger();
        }
    }
    trigger() {
        try {
            if (!this.$gaCategoryDirective) {
                throw new Error('You must provide a gaCategory attribute w/ gaEvent Directive.');
            }
            if (!this.gaAction) {
                throw new Error('You must provide a gaAction atrribute to identify this event.');
            }
            this.$gaService
                .event(this.gaAction, this.$gaCategoryDirective.gaCategory, this.gaLabel || this.label, this.gaValue, this.gaInteraction);
        }
        catch (err) {
            this.throw(err);
        }
    }
    throw(err) {
        if (console && console.warn) {
            console.warn(err);
        }
    }
}
GaEventDirective.ɵfac = function GaEventDirective_Factory(t) { return new (t || GaEventDirective)(ɵngcc0.ɵɵdirectiveInject(GaEventCategoryDirective, 8), ɵngcc0.ɵɵdirectiveInject(GoogleAnalyticsService)); };
GaEventDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: GaEventDirective, selectors: [["", "gaEvent", ""]], hostBindings: function GaEventDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function GaEventDirective_click_HostBindingHandler() { return ctx.onClick(); })("focus", function GaEventDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function GaEventDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { gaBind: "gaBind", gaAction: "gaAction", gaLabel: "gaLabel", label: "label", gaValue: "gaValue", gaInteraction: "gaInteraction" }, exportAs: ["gaEvent"] });
GaEventDirective.ctorParameters = () => [
    { type: GaEventCategoryDirective, decorators: [{ type: Optional }] },
    { type: GoogleAnalyticsService }
];
GaEventDirective.propDecorators = {
    gaAction: [{ type: Input }],
    gaLabel: [{ type: Input }],
    label: [{ type: Input }],
    gaValue: [{ type: Input }],
    gaInteraction: [{ type: Input }],
    gaBind: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaEventDirective, [{
        type: Directive,
        args: [{
                selector: `[gaEvent]`,
                exportAs: 'gaEvent'
            }]
    }], function () { return [{ type: GaEventCategoryDirective, decorators: [{
                type: Optional
            }] }, { type: GoogleAnalyticsService }]; }, { gaBind: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], gaAction: [{
            type: Input
        }], gaLabel: [{
            type: Input
        }], label: [{
            type: Input
        }], gaValue: [{
            type: Input
        }], gaInteraction: [{
            type: Input
        }] }); })();

class GaEventFormInputDirective {
    constructor($gaEvent) {
        this.$gaEvent = $gaEvent;
    }
    ngOnInit() {
        if (this.$gaEvent) {
            this.$gaEvent.gaBind = (this.gaBind)
                ? this.$gaEvent.gaBind
                : 'focus';
        }
    }
}
GaEventFormInputDirective.ɵfac = function GaEventFormInputDirective_Factory(t) { return new (t || GaEventFormInputDirective)(ɵngcc0.ɵɵdirectiveInject(GaEventDirective, 9)); };
GaEventFormInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: GaEventFormInputDirective, selectors: [["input", "gaEvent", ""], ["select", "gaEvent", ""], ["textarea", "gaEvent", ""]], inputs: { gaBind: "gaBind" } });
GaEventFormInputDirective.ctorParameters = () => [
    { type: GaEventDirective, decorators: [{ type: Host }, { type: Optional }] }
];
GaEventFormInputDirective.propDecorators = {
    gaBind: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GaEventFormInputDirective, [{
        type: Directive,
        args: [{
                selector: `input[gaEvent],
             select[gaEvent],
             textarea[gaEvent]`
            }]
    }], function () { return [{ type: GaEventDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }]; }, { gaBind: [{
            type: Input
        }] }); })();

class NgxGoogleAnalyticsModule {
    static forRoot(trackingCode, commands = [], uri) {
        return {
            ngModule: NgxGoogleAnalyticsModule,
            providers: [
                {
                    provide: NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
                    useValue: {
                        trackingCode: trackingCode,
                        commands: commands,
                        uri: uri
                    }
                },
                NGX_GOOGLE_ANALYTICS_INITIALIZER_PROVIDER,
            ]
        };
    }
}
NgxGoogleAnalyticsModule.ɵfac = function NgxGoogleAnalyticsModule_Factory(t) { return new (t || NgxGoogleAnalyticsModule)(); };
NgxGoogleAnalyticsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxGoogleAnalyticsModule });
NgxGoogleAnalyticsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxGoogleAnalyticsModule, { declarations: [GaEventDirective, GaEventCategoryDirective, GaEventFormInputDirective], exports: [GaEventDirective, GaEventCategoryDirective, GaEventFormInputDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxGoogleAnalyticsModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [GaEventDirective, GaEventCategoryDirective, GaEventFormInputDirective],
                exports: [GaEventDirective, GaEventCategoryDirective, GaEventFormInputDirective]
            }]
    }], null, null); })();

class NgxGoogleAnalyticsRouterModule {
}
NgxGoogleAnalyticsRouterModule.ɵfac = function NgxGoogleAnalyticsRouterModule_Factory(t) { return new (t || NgxGoogleAnalyticsRouterModule)(); };
NgxGoogleAnalyticsRouterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxGoogleAnalyticsRouterModule });
NgxGoogleAnalyticsRouterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        NGX_GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER
    ], imports: [[
            CommonModule,
            NgxGoogleAnalyticsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxGoogleAnalyticsRouterModule, { imports: function () { return [CommonModule, NgxGoogleAnalyticsModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxGoogleAnalyticsRouterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgxGoogleAnalyticsModule
                ],
                providers: [
                    NGX_GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER
                ],
                declarations: []
            }]
    }], null, null); })();

/**
 * Analytics
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsModule, AnalyticsService, GaEventCategoryDirective, GaEventDirective, GaEventFormInputDirective, GoogleAnalyticsInitializer, GoogleAnalyticsRouterInitializer, GoogleAnalyticsService, NGX_GOOGLE_ANALYTICS_INITIALIZER_PROVIDER, NGX_GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER, NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN, NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule, TrackerModule, TrackerService, trackerInjection };

//# sourceMappingURL=dharma-ui-analytics.js.map